// extracted by mini-css-extract-plugin
export default {"menuBlock":"NE-z","title":"OE-z","nav":"PE-z","flexCell":"QE-z","facetLink":"RE-z"};